import ReactDOM from "react-dom/client";
import reportWebVitals from "./reportWebVitals";
import { ChakraProvider } from "@chakra-ui/react";
import { MsalProvider } from "@azure/msal-react";
import { AuthProvider } from "./context-providers/auth-provider";
import Router from "./Router";
import Theme from "./styles/theme";
import { msalInstance } from "./msalConfig";

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(
	<MsalProvider instance={msalInstance}>
		<AuthProvider>
			<ChakraProvider theme={Theme}>
				<Router />
			</ChakraProvider>
		</AuthProvider>
	</MsalProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
